"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:import-blacklist */
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var CreateWorkbookFromTemplateMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/CreateWorkbookFromTemplateMethod");
var GetDestinationProjectsMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetDestinationProjectsMethod");
var es6_promise_1 = require("es6-promise");
require("whatwg-fetch");
es6_promise_1.polyfill();
var VizportalApiService = /** @class */ (function () {
    function VizportalApiService() {
        this.vizportalWebClientrequester = new vizportal_webclient_api_1.VizPortalWebClientRequester();
        this.sessionManager = new vizportal_webclient_api_1.SessionManager(this.vizportalWebClientrequester);
    }
    VizportalApiService.GetSessionInfo = function () {
        if (!VizportalApiService.instance) {
            VizportalApiService.instance = new VizportalApiService();
        }
        var sessionInfo = VizportalApiService.instance.sessionManager.getSession();
        return new Promise(function (resolve, reject) {
            if (sessionInfo === null || sessionInfo === undefined) {
                VizportalApiService.instance.sessionManager
                    .ensureSessionInfo()
                    .then(function () { return VizportalApiService.instance.sessionManager.getSession(); })
                    .then(function (response) {
                    if (response !== null && response !== undefined) {
                        resolve(response);
                    }
                    else {
                        reject();
                    }
                });
            }
            else {
                resolve(sessionInfo);
            }
        });
    };
    VizportalApiService.CreateWorkbookFromTemplate = function (templateId, templateName, credentialId, projectId, connectionName) {
        if (!VizportalApiService.instance) {
            VizportalApiService.instance = new VizportalApiService();
        }
        var params = {
            templateId: templateId,
            templateName: templateName,
            credentialId: credentialId,
            projectId: projectId,
            connectionName: connectionName,
        };
        var createWorkbookFromTemplate = VizportalApiService.instance.vizportalWebClientrequester.createSender(CreateWorkbookFromTemplateMethod_1.CreateWorkbookFromTemplateMethod);
        return new Promise(function (resolve, reject) {
            createWorkbookFromTemplate(params).then(function (resp) {
                if (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(resp)) {
                    var result = resp.response.result;
                    resolve(result);
                }
                else {
                    reject();
                }
            });
        });
    };
    VizportalApiService.GetDestinationProjects = function () {
        if (!VizportalApiService.instance) {
            VizportalApiService.instance = new VizportalApiService();
        }
        return VizportalApiService.instance.GetDestinationProjectsImpl();
    };
    VizportalApiService.prototype.GetDestinationProjectsImpl = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var projects = new Array();
            _this.GetDestinatonProjectsItems(0, function (newProjects) {
                projects = projects.concat(newProjects);
            }, function () {
                resolve(projects);
            }, function () {
                reject(projects);
            });
        });
    };
    VizportalApiService.prototype.GetDestinatonProjectsItems = function (startIdx, onProjectsAdded, onComplete, onError) {
        var _this = this;
        var params = new GetDestinationProjectsMethod_1.GetDestinationProjectParams('workbook', startIdx);
        var getDestinationProjects = this.vizportalWebClientrequester.createSender(GetDestinationProjectsMethod_1.GetDestinationProjectsMethod);
        getDestinationProjects(params).then(function (resp) {
            if (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(resp)) {
                var result = resp.response.result;
                onProjectsAdded(result.projects);
                if (!result.moreItems) {
                    onComplete();
                }
                else {
                    _this.GetDestinatonProjectsItems(startIdx + result.projects.length, onProjectsAdded, onComplete, onError);
                }
            }
            else {
                onError();
            }
        });
    };
    return VizportalApiService;
}());
exports.VizportalApiService = VizportalApiService;
//# sourceMappingURL=VizportalApi.js.map